import { Injectable }           from '@angular/core';
import { Http, Response }       from '@angular/http';
import { Observable }           from 'rxjs/Observable';
import { ConfigService }        from '../configuracion/config.service';
import { RequestBaseService }   from '../request-base/request-base.service';
import { JwtHttp, AuthService } from 'ng2-ui-auth';
  
@Injectable()
export class TiqueteService extends RequestBaseService{
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'tiquete'].join('/');
  }

  public joinPuestos(viajes: Array<any>): Array<number> {
    let puestos = [];

    viajes.forEach(vj => {
      puestos = puestos.concat(JSON.parse(vj.puestos));
    });

    return puestos.filter((pto, index) => { return puestos.indexOf(pto) === index });
  }

  public getPorCerrar() {
    this.validate();

    return this.http
      .get([this.ApiUrl, 'por-cerrar'].join('/'))
      .map(res => res.json());
  }

  public getTicketsBetweenDates(fechaInicial, fechaFinal): Observable<any> {
    this.validate();

    return this.http
      .get([this.ApiUrl, 'fecha', fechaInicial, fechaFinal].join('/'))
      .map(res => res.json());    
  }
}



// WEBPACK FOOTER //
// ./src/app/services/tiquete/tiquete.service.ts